import Image from "next/image";
import Link from "next/link";

export function LatestBlogs({ latestArticles }) {
  return (
    <div className="w-full space-y-8 hidden lg:block">
      <h6 className="font-semibold text-[1.125rem] text-grayD2">
        Latest Blogs
      </h6>
      <div className="flex flex-col gap-4">
        {latestArticles.map((blog, index) => (
          <div key={index} className="w-full">
            <div className="flex gap-4 w-full">
              <Image
                src={blog.thumbnail}
                alt={blog.title}
                width={104}
                height={70}
                className="rounded-lg object-contain"
              />
              <div className="flex flex-col gap-1 w-full">
                <p className="text-grayD2 h-[40px] font-medium line-clamp-2 leading-[20.16px]">
                  {blog.title}
                </p>
                <Link
                  href={`/blogs/${blog.slug}`}
                  className="text-primary-default"
                >
                  Read More
                </Link>
              </div>
            </div>
            <div className="mb-[0.5rem] mt-[1rem] border border-grayD8" />
          </div>
        ))}
      </div>
    </div>
  );
}
